import Login from "./login";
import _request from "actions/_request";
import { Alert, Box } from "@mui/material";

export default class Forgot extends Login {
    constructor(props) {
        super(props);

        this.titles = {
            rightTitle: "login",
            mainTitle: "forgotPass",
            smallTitle: "forgotSmall",
        };
    }

    isButtonDisabled() {
        return this.state.email.length < 6;
    }

    async mainButtonClick() {
        const { email } = this.state;

        if (!this.validateEmail(email))
            return false;

        const resp = await _request.auth.loading(async () => {
            return await _request.auth.forgot({ email });
        });

        if (resp?.isOk) {
            this.setState({ emailSent: true });
        } else {
            this.setState({ errorMessage: "There was an issue sending the email. Please try again after 5 minutes." });
        }
    }

    renderForm() {
        const { emailSent, errorMessage } = this.state;

        if (emailSent) {
            return (
                <Box className="flex column gap24">
                    <Alert severity="success">
                        A password reset email has been sent to your address. Please check your inbox. If you do not receive it, you can try again after 5 minutes.
                    </Alert>
                </Box>
            );
        }

        if (errorMessage) {
            return (
                <Box className="flex column gap24">
                    <Alert severity="error">{errorMessage}</Alert>
                </Box>
            );
        }

        return (
            <Box className="flex column gap24">
                {this.insertEmail("email")}
                {this.insertButton("send")}
            </Box>
        );
    }
}